import {
  DietitianClinicBillingProfileResource,
  dietitianClinicBillingProfileResourceSchema,
} from "@client/resources/DietitianClinicBillingProfileResource";
import type { UpdateClinicBillingProfileRequest } from "@client/requests";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type UpdateBillingProfileResponse =
  ApiResponse<DietitianClinicBillingProfileResource>;

const schema = object({
  data: dietitianClinicBillingProfileResourceSchema.defined(),
});

export const updateBillingProfile = async (
  payload: UpdateClinicBillingProfileRequest,
): Promise<UpdateBillingProfileResponse> => {
  const response = await fetchData(
    "/dietitian/clinic/billing-profile",
    APIMethods.PUT,
    payload,
  );

  return await schema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/clinic/billing-profile"));
};
